import { CONTRACTS_DATA } from "../../../../constants";

export const initialState = {
  loading: false,
  isAddExistingPriceClass: false,
  contractPrceClasses: [],
  deletePriceClasses: [],
  contractServiceOfferings: [],
  contractSearchServiceOfferings: [],
  contractRentalServiceOfferings: [],
  DeferralPriceClasses: [],
  priceClassesSearch: {
    name: '',
    description: '',
  },
  addNewPriceClassSelectedRow: [],
  addedPriceClassesSelectedGridData: [],
  contractTabSelectedValue: 0,
  selectedContractFeeTypeId: 0,
  selectedZoneId: 0,
  selectedPriceOptionTab: 2,
  priceClassesName: '',
  serviceOfferingData: {
    annualFee: 0,
    percentMargin: 0,
  },
  calculationFee: 0,
  priceClassSelectionTabLoader: false,
  contractData: null,
  deferralPriceClassSearch: null,
  deferralPriceClassAlert: false,
  zoneselectedPriceClass: null,
  selectedOptions_PriceClassSelection: [],
  existingContractServiceOfferings: [],
  selectedPriceClassData: null,
  selectedPCIndex: null,
  selectedPCDeleted: null,
  newDynamicObject: [],
  selectedOtionsUpdateData: {
    shortName: '',
    description: '',
    lastModifiedUserId: 0,
    general: {
      syncContractId: 0,
      retailPercentage: 0,
      retailPercentageFlag: '',
      transferHwDeactivateFlag: '',
      contractStartDate: '',
      contractStartDateSAVE: '',
      contractEndDate: '',
      contractEndDateSAVE: '',
      defaultZoneId: 0,
      currentDefaultZoneName: '',
      previousDefaultZoneName: '',
      currentFreightFwdCountryName: '',
      previousFrightFwdCountryName: '',
      deferralCountryId: 0,
      currentDeferralCountryName: '',
      previousDeferralCountryName: '',
    },
    billing: {
      billingGeneral: {
        cycleId: 0,
        currencyId: 0,
        currentCycleName: '',
        previousCycleName: '',
        currentCurrencyName: '',
        previousCurrencyName: '',
        daysOut: 0,
        exceptionFlag: '',
        exceptionNote: '',
        prepaymentDays: 0,
        autoBillFlag: '',
      },
      oos: {
        billSupportFlag: '',
        nonStandardFeeFlag: '',
        billSetId: 0,
        currentBillSetName: '',
        previousBillSetName: '',
      },
      cpi: {
        eligibleFlag: '',
        maxValue: 0,
        minValue: 0,
      },
      isBillingGeneralDataChanged: false,
      isOosDataChanged: false,
      isCpiDataChanged: false,
    },
    warranty: {
      newDuration: 0,
      standardDuration: 0,
      installDelayDays: 0,
      autoInstallFlag: 'n',
      standarDeferralFlag: '',
    },
    etrack: {
      accessFlag: '',
      importLimitYears: 0,
      searchLimitYears: 0,
    },
    isGeneralDataChanged: false,
    isBillingDataChanged: false,
    isWarrantyDataChanged: false,
    isEtrackDataChanged: false,
    contractStatus: '',
    priceClassId: 0,
  },
  selectedOptionsSave: null,
  contractBillSets: [],
  contractBillCycles: [],
  defaultPriceOptions: [],
  isSelectedOptionsSave: false,
  apiSuccessResponse: {
    update: null,
  },
  isHandleChange: false,
  isExtendedAPISuccess: null,
  isPriceOptionsLoading: false,
  servicingOfferingLoading: false,
  deferralPriceClassLoading: false,
  priceClassLoading: false,
  deferralServicingOfferingLoading: false,
  deferralServiceOfferings: [],
  deferralPriceClasses: [],
  extendedWarraySaveLoading: false,
  priceClassAlreadyAdded: false,
  isDataToSave: [],
  isSaveAndClose: false,
  contractId: 0,
  selectedOptionPriceClassesLoading: false,
  selectedOptions_PriceClassesData: [],
  existingContractPriceClasses: [],
  warrantyPeriodTabData: [],
  rentalPriceClassAdded: null,
  nonRentalPriceClassAdded: null,
  cpiLoading: false,
  soCount: 0,
  soDeferralCount: 0,
  selectedOpDefServiceOffering: [],
  selectedOptionAlert: false,
  selectedOptionAlertText: CONTRACTS_DATA.alertTextMessage,
  isSelectedOptionsSaveSuccesfully: null,
  trickleDownFields: {
    defaultZoneId: false,
    cycleId: false, // Already taken care at backend. Not need to check on UI. but kept this value for refernce.
    newDuration: false,
    standardDuration: false,
  },
  isTrickleDownChecked: false,
  submitForApprovalSaveLoader: false,
  trickleDownAPIResponse: null,
  trickleDownLoading: false,
  isTDSuccess: null,
  readyForApproveOnClose: false,
  isPriceClassOptionsChanged: false,
  isPriceClassSelectionChanged: false,
  priceClassOptionsToSave: [],
  SODefServiceOfferingLoading: false,
  s_O_P_C_Datafound: false,
  warrantySaveAPIResponse: null,
  exServiceSaveAPIResponse: null,
  onAlertSave: false,
};
